import { OreStack, OreWysiwyg } from '@edenredespana/oreneta'
import { useTranslation } from 'react-i18next'

import { SignUpTranslation } from '@/AutoEnrollment/ui/autoEnrollmentTranslation'
import { SignUpForm } from '@/AutoEnrollment/ui/organisms'
import { PageWrapper } from '@/Shared/ui/layout'

export const SignUpPage = (): JSX.Element => {
  const { t } = useTranslation()

  return (
    <PageWrapper
      paddingSmaller
      title={t(SignUpTranslation.pageTitle)}
      subtitle={t(SignUpTranslation.pageSubTitle)}
      titleSize="title-md"
    >
      <OreStack space="xlarge">
        <OreWysiwyg>
          <div
            dangerouslySetInnerHTML={{
              __html: t(SignUpTranslation.pageWysiwyg),
            }}
          />
        </OreWysiwyg>
        <SignUpForm />
      </OreStack>
    </PageWrapper>
  )
}
